import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import Swiper from "react-id-swiper";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDownload,
    faCar,
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import './tucson.css';
/***showroom virtual */
import showroom from "../../images/showroom/tucson.png";
/**** Fotos Banner ****/
import Slider1 from "../../images/modelos/nuevotucson/banner/tucson-banner-1.webp";
import Slider2 from "../../images/modelos/nuevotucson/banner/tucson-banner-2.webp";
import Slider3 from "../../images/modelos/nuevotucson/banner/tucson-banner-3.webp";
import Slider4 from "../../images/modelos/nuevotucson/banner/tucson-banner-4.webp";
import Slider5 from "../../images/modelos/nuevotucson/banner/tucson-banner-5.webp";
/****Fotos calidad de tiempo ****/
import Calidad1 from "../../images/modelos/nuevotucson/calidad/tucson-calidad1.webp";
import Calidad2 from "../../images/modelos/nuevotucson/calidad/tucson-calidad2.webp";
import Calidad3 from "../../images/modelos/nuevotucson/calidad/tucson-calidad3.webp";
import Galeria1 from "../../images/modelos/nuevotucson/galeria/tucson-galeria-1.webp";
import Galeria2 from "../../images/modelos/nuevotucson/galeria/tucson-galeria-2.webp";
import Galeria3 from "../../images/modelos/nuevotucson/galeria/tucson-galeria-3.webp";
import Galeria4 from "../../images/modelos/nuevotucson/galeria/tucson-galeria-4.webp";
import Galeria5 from "../../images/modelos/nuevotucson/galeria/tucson-galeria-5.webp";
/****Fotos disenio ****/
import Interior1 from "../../images/modelos/nuevotucson/disenio/tucson-interior-1.webp";
import Interior2 from "../../images/modelos/nuevotucson/disenio/tucson-interior-2.webp";
import Interior3 from "../../images/modelos/nuevotucson/disenio/tucson-interior-3.webp";
import Interior4 from "../../images/modelos/nuevotucson/disenio/tucson-interior-4.webp";
import Interior5 from "../../images/modelos/nuevotucson/disenio/tucson-interior-5.webp";
import Interior6 from "../../images/modelos/nuevotucson/disenio/tucson-interior-6.webp";
/****Fotos rendimiento ****/
import Rendimiento1 from "../../images/modelos/nuevotucson/rendimiento/tucson-rendimiento-1.webp";
import Rendimiento2 from "../../images/modelos/nuevotucson/rendimiento/tucson-rendimiento-2.webp";
import Rendimiento3 from "../../images/modelos/nuevotucson/rendimiento/tucson-rendimiento-3.webp";
/****Fotos seguridad ****/
import Seguridad1 from "../../images/modelos/nuevotucson/seguridad/tucson-seguridad-1.webp";
import Seguridad2 from "../../images/modelos/nuevotucson/seguridad/tucson-seguridad-2.webp";
import Seguridad3 from "../../images/modelos/nuevotucson/seguridad/tucson-seguridad-3.webp";
import Seguridad4 from "../../images/modelos/nuevotucson/seguridad/tucson-seguridad-4.webp";
import Seguridad5 from "../../images/modelos/nuevotucson/seguridad/tucson-seguridad-5.webp";
import Seguridad6 from "../../images/modelos/nuevotucson/seguridad/tucson-seguridad-6.webp";
/****Fotos conveniencia ****/
import Conveniencia1 from "../../images/modelos/nuevotucson/conveniencia/tucson-conveniencia-1.webp";
import Conveniencia2 from "../../images/modelos/nuevotucson/conveniencia/tucson-conveniencia-2.webp";
import Conveniencia3 from "../../images/modelos/nuevotucson/conveniencia/tucson-conveniencia-3.webp";
/****Ficha técnica ****/
import TucsonCatalogo from "../../fichas/nuevo-tucson-brochure.pdf";

function InfoNuevoTucson() {
    const [gallerySwiper, getGallerySwiper] = useState(null);
    const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
    const gallerySwiperParams = {
        getSwiper: getGallerySwiper,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    };

    const thumbnailSwiperParams = {
        getSwiper: getThumbnailSwiper,
        slidesPerView: 5,
        loop: true,
        freeMode: true,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: true,
    };

    useEffect(() => {
        if (
            gallerySwiper !== null &&
            gallerySwiper.controller &&
            thumbnailSwiper !== null &&
            thumbnailSwiper.controller
        ) {
            gallerySwiper.controller.control = thumbnailSwiper;
            thumbnailSwiper.controller.control = gallerySwiper;
        }
    }, [gallerySwiper, thumbnailSwiper]);

    const onChangeMenu = (menu) => {
        switch (menu) {
            case "calidad":
                document.getElementById("tab-calidad").className = "color-hover";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-block";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider1;
                break;
            case "disenio":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-hover";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-block";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider2;
                break;
            case "rendimiento":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-hover";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-block";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider3;
                break;
            case "seguridad":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-hover";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-block";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider4;
                break;
            case "conveniencia":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-hover";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-block";
                document.getElementById("img-carrusel").src = Slider5;
                break;
            default:
                break;
        }
    };

    return (
        <Fragment>
            <link rel="preload" as="image" href={Slider1} />
            <link rel="preload" as="image" href={Calidad2} />
            <link rel="preload" as="image" href={Calidad1} />
            <link rel="preload" as="image" href={Calidad3} />
            <link rel="preload" as="image" href={Galeria1} />
            <link rel="preload" as="image" href={Galeria2} />
            <link rel="preload" as="image" href={Galeria3} />
            <link rel="preload" as="image" href={Galeria4} />
            <link rel="preload" as="image" href={Galeria5} />
            <Container fluid={true}>
                <Row>
                    <Col md={12} className="px-0">
                        <div>
                            <Image
                                src={Slider1}
                                fluid
                                alt="Tucson Banner"
                                className="banner"
                                id="img-carrusel"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="menu-vehiculo sticky-top">
                <Container>
                    <Row className="py-2 py-md-4">
                        <Col xs={2} md={2} className="my-auto d-none d-sm-block">
                            <h1 className="menu-modelo">EL TUCSON</h1>
                        </Col>
                        <Col
                            xs={12}
                            md={6}
                            className="my-auto vehiculo-item text-md-center px-0"
                        >
                            <ul className="my-auto p-0 m-0">
                                <li
                                    id="tab-calidad"
                                    onClick={() => onChangeMenu("calidad")}
                                    className="color-hover"
                                >
                                    Calidad de tiempo
                                </li>
                                <li
                                    id="tab-disenio"
                                    onClick={() => onChangeMenu("disenio")}
                                    className="color-normal"
                                >
                                    Diseño
                                </li>
                                <li
                                    id="tab-rendimiento"
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="color-normal"
                                >
                                    Rendimiento
                                </li>
                                <li
                                    id="tab-seguridad"
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="color-normal"
                                >
                                    Seguridad
                                </li>
                                <li
                                    id="tab-conveniencia"
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="color-normal"
                                >
                                    Conveniencia
                                </li>
                            </ul>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra">
                            <a
                                href="static/media/nuevo-tucson-ficha-tecnica.8ea68457.pdf"
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Ficha</span>
                            </a>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <a
                                href={TucsonCatalogo}
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Catálogo</span>
                            </a>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <Link
                                to="/cotizador/nuevo-tucson"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra"> Cotizar</span>
                            </Link>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <Link
                                to="/test-drive/nuevo-tucson"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra"> Test Drive</span>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/***************************************** calidad ***************************************/}
            <section id="calidad">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">Tucson</h2>
                            <h2 className="model-title">El dueño de la ciudad</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Llegó el Tucson, el dueño de la ciudad. Este icónico SUV de Hyundai se renueva con
                                un diseño audaz y funciones emocionantes que marcan el inicio de una era digital. Su interior
                                completamente renovado, junto con tecnología avanzada, lo convierten en el compañero ideal
                                para conquistar cada aventura urbana.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="bg-black py-2 px-2 py-md-4 px-md-0">
                            <Image src={Calidad1} alt="Tucson Calidad" className="img-fluid1" fluid />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto order-2 order-md-1">
                                <h3 className="specs-subtitle mt-3 px-3 px-md-0">
                                    Más tecnológico y dinámico
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    Con su interior totalmente renovado, y una presencia imponente,
                                    el Nuevo Tucson redefine el concepto de SUV.
                                </p>
                            </Col>
                            <Col md={6} className="my-auto order-1 order-md-2">
                                <Image src={Calidad2} alt="Tucson Calidad2" className="img-fluid2" fluid />
                            </Col>
                        </Row>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto">
                                <Image src={Calidad3} alt="Tucson Calidad3" className="img-fluid2" fluid />
                            </Col>
                            <Col md={6} className="my-auto">
                                <h3 className="specs-subtitle mt-3 px-3 px-md-0">
                                    Diseño único
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    El Tucson evoluciona para ofrecer una identidad robusta y elegante,
                                    capturando todas las miradas.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="py-3 py-md-5">
                        <Col md={12} className="text-center">
                            <h2 className="galeria-titulo my-3 pb-2 pb-md-4">Galería</h2>
                            <div>
                                <Swiper {...gallerySwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            fluid
                                            alt="Tucson Slider 1"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria2}
                                            fluid
                                            alt="Tucson Slider 2"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            fluid
                                            alt="Tucson Slider 3"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            fluid
                                            alt="Tucson Slider 4"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            fluid
                                            alt="Tucson Slider 5"
                                            className="galeria1"
                                        />
                                    </div>
                                </Swiper>
                                <Swiper {...thumbnailSwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            fluid
                                            alt="Tucson Slider 1"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria2}
                                            fluid
                                            alt="Tucson Slider 2"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            fluid
                                            alt="Tucson Slider 3"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            fluid
                                            alt="Tucson Slider 4"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            fluid
                                            alt="Tucson Slider 5"
                                            className="galeria2"
                                        />
                                    </div>
                                </Swiper>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6}></Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    Diseño
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** disenio ***************************************/}
            <section id="disenio" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title mb-0">Diseño Exterior</h2>
                            <h2 className="model-title-sub">El dueño de la ciudad</h2>
                            <p className="model-text mt-3 px-3 px-md-0">
                                El Tucson impone su ley con un perfil audaz y paneles protectores renovados.
                                Cada línea fluye con armonía desde la parrilla central hasta la parte trasera,
                                revelando una silueta atlética y sofisticada. Potencia visual y estilo urbano se
                                unen para conquistarlo todo a tu paso.
                            </p>
                            <a href="https://my.matterport.com/show/?m=CjWvEZs9qAp" target="_brown" rel="noopener noreferrer">
                                <center>
                                    <Image src={showroom} alt="Showroom Virtual Tucson" fluid width={700} height={350} />
                                </center>
                            </a>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="pt-3 pt-md-5">
                            <Col md={12} className="text-center">
                                <h2 className="model-title mb-0">Diseño Interior</h2>
                                <h2 className="model-title-sub">Confort y tecnología en perfecta armonía</h2>
                                <p className="specs-text mt-3 px-3 px-md-0">
                                    Al entrar, la innovación te envuelve: asientos ergonómicos, conectividad de vanguardia
                                    y sistemas de seguridad intuitivos que simplifican cada trayecto.
                                    En el Tucson cada detalle está diseñado para que disfrutes de un espacio
                                    moderno y refinado, listo para conquistar la ciudad.
                                </p>

                                <Image src={Interior1} alt="Tucson Interior" fluid />
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-2 mt-4">
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior2} alt="Tucson tablero" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    <b>
                                        Cluster Digital 12.3” renovado
                                    </b>
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior3} alt="Tucson Pantalla" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    <b>
                                        Climatizador automático BI - ZONA
                                    </b>
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior4} alt="Tucson Luces" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    <b>
                                        Cargador Wireless para celular
                                    </b>
                                </h3>
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-4">
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior5} alt="Tucson tablero" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    <b>
                                        Recordatorio de objetos en el asiento trasero (ROA)
                                    </b>
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior6} alt="Tucson Pantalla" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    <b>
                                        Hyundai Smart Sense
                                        Asistencias de conducción
                                    </b>
                                </h3>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("calidad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Calidad de tiempo
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    Rendimiento
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** rendimiento ***************************************/}
            <section id="rendimiento" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title mb-0">Potencia y Rendimiento</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Hyundai Tucson presenta dos tipos de motorización: un motor 2.0 Smartstream con 154 HP y un motor
                                híbrido de 1.6 turbo con 178 HP.
                            </p>
                        </Col>
                    </Row>
                    <Row className="pb-3 pb-md-4 d-flex justify-content-center">
                        <Col md={4} className="mt-4 mt-md-4">
                            <Image src={Rendimiento1} alt="Tucson tablero" fluid />

                        </Col>
                        <Col md={4} className="mt-4 mt-md-4">
                            <Image src={Rendimiento2} alt="Tucson Luces" fluid />

                        </Col>
                    </Row>
                    <Row className="pb-3 pb-md-4 d-flex mt-md-4 justify-content-center">
                        <Col md={12} className="mt-4 mt-md-4">
                            <Image
                                src={Rendimiento3}
                                alt="Tucson tablero"
                                className="w-100"
                                fluid
                            />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Diseño
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    Seguridad
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** seguridad ***************************************/}
            <section id="seguridad" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title mb-0">Seguridad</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Incorpora la tecnología Hyundai Smart Sense como frenado autónomo con asistencia en giros,
                                control de crucero, 6 airbags, luces de curva, freno de disco en las 4 llantas,
                                luces automáticas, freno de parqueo electrónico.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <Row className="py-3 py-md-5">
                        <Col md={4}>
                            <Image src={Seguridad1} alt="Tucson Cinturones" fluid />
                        </Col>
                        <Col md={4}>
                            <Image src={Seguridad2} alt="Tucson Carroceria" fluid />
                        </Col>
                        <Col md={4}>
                            <Image src={Seguridad3} alt="Tucson Carroceria" fluid />
                        </Col>
                    </Row>
                    <Row className="py-3 py-md-5">
                        <Col md={4}>
                            <Image src={Seguridad4} alt="Tucson Cinturones" fluid />
                        </Col>
                        <Col md={4}>
                            <Image src={Seguridad5} alt="Tucson Carroceria" fluid />
                        </Col>
                        <Col md={4}>
                            <Image src={Seguridad6} alt="Tucson Carroceria" fluid />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Rendimiento
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="titulo-navegacion"
                                >
                                    Conveniencia
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** conveniencia ***************************************/}
            <section id="conveniencia" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">Tecnología avanzada y un enfoque en confort superior</h2>
                            <p className="model-text mb-md-3 mt-3 px-3 px-md-0">
                                El Hyundai Tucson destaca por su lenguaje de diseño “Parametric Dynamics”,
                                que integra líneas dinámicas y luces ocultas en su parrilla Parametric Jewel.
                                Este enfoque audaz y sofisticado redefine el estilo en el segmento de los SUV's.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={4}>
                                <Image
                                    src={Conveniencia1}
                                    alt="Tucson mandos integrados volante"
                                    fluid
                                />
                                <p className="specs-text px-3 px-md-0">
                                    Cubre maletero retráctil.
                                </p>
                            </Col>
                            <Col md={4}>
                                <Image src={Conveniencia2} alt="Tucson botón encendido" fluid />
                                <p className="specs-text px-3 px-md-0">
                                    Consola central flotante.
                                </p>
                            </Col>
                            <Col md={4}>
                                <Image src={Conveniencia3} alt="Tucson ducto ventilación" fluid />

                                <p className="specs-text px-3 px-md-0">
                                    Toma de 12volt. / Puertos USB tipo C.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Seguridad
                                </span>
                            </Col>
                            <Col xs={6} md={6}></Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </Fragment>
    );
}
export default InfoNuevoTucson;